//#region import
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { numberWithCommas } from '../../../../utils/consts/index';
import { bookingApi } from '../../../../services/apis';
import { checkMobileDevice } from '../../../../utils/utility/index';
import { profileRoutes } from '../../../../utils/consts/routes';
import { RadioButton, Checkbox, Modal } from '../../../../component';
import propTypes from 'prop-types';
//#endregion
//#region  Global Vraiable
let penaltyTotalPrice = 0;
let penaltyPriceFlight = [];
//#endregion
class CancelingProcessModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      cancelFlightType: this.props.cancelFlightType,
      creditPayment: false,
      cancelFlightIndex: 0,
      agree: false,
      hasUndefinedPrice: false,
      showNextStep: false,
      penalty: [],
      selectedPassenger: [],
      radioObj: this.props.radioObj,
    };
  }

  //#region component life cycle
  UNSAFE_componentWillReceiveProps() {
    this.setState({ step: 1 });
  }
  //#endregion
  //#region fetch API
  // call cancel api to cancel ticket request
  cancelTickets = (id) => {
    let { selectedPassenger, currentFlightId, flights } = this.props;
    let { cancelFlightIndex } = this.state;
    let { radioObj } = this.state;
    let { hasUndefinedPrice } = this.state;
    let finalSelectedPassenger = [];
    for (let key in selectedPassenger[0]) {
      if (this.state.selectedPassenger[0][key])
        finalSelectedPassenger.push(key);
    }
    let obj = [];
    finalSelectedPassenger.forEach((element) => {
      // all flight should be cancel
      if (cancelFlightIndex === 0) {
        flights.length &&
          flights
            .filter((item) => item._id === currentFlightId)[0]
            .flights.itineraries.map((flight, index) => {
              obj.push({
                id: id,
                passengerIndex: parseInt(element),
                flightIndex: parseInt(index),
                creditPayment: this.state.creditPayment,
                cancelReason: radioObj.filter(
                  (item) => item.selected === true,
                )[0].name,
                penalty: hasUndefinedPrice
                  ? -1
                  : penaltyPriceFlight.length
                  ? penaltyPriceFlight.filter(
                      (item) =>
                        item.passengerIndex === parseInt(element) &&
                        item.flightIndex === parseInt(index),
                    )[0].penalty
                  : -1,
              });
            });
      } else {
        let finalPenaltyPrice = penaltyPriceFlight.length
          ? penaltyPriceFlight.filter(
              (item) =>
                item.passengerIndex === parseInt(element) &&
                item.flightIndex === parseInt(cancelFlightIndex),
            )[0].penalty
          : -1;
        obj.push({
          id: id,
          passengerIndex: parseInt(element),
          flightIndex: parseInt(cancelFlightIndex),
          creditPayment: this.state.creditPayment,
          cancelReason: radioObj.filter((item) => item.selected === true)[0]
            .name,
          penalty: hasUndefinedPrice ? -1 : finalPenaltyPrice,
        });
      }
    });
    try {
      bookingApi
        .cancel({ data: obj })
        .then((result) => {
          if (result.status === 200) {
            this.setState({ step: 4 });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error(error);
    }
  };
  //#endregion
  //#region Handle Controls
  //handler to get checked of  reason
  handlerchange = (index) => {
    let { radioObj } = this.state;

    for (let ind = 0; ind < radioObj.length; ind++) {
      if (ind === index) {
        radioObj[ind].selected = true;
      } else radioObj[ind].selected = false;
    }
    this.setState({ radioObj });
  };

  //handle check or uncheck of each passenger
  handlerAgreechange = (event) => {
    // if (event.target) this.setState({ agree: event.target.checked });

    let { selectedPassenger } = this.state;
    if (selectedPassenger[0]) {
      for (let i = 0; i < Object.entries(selectedPassenger[0]).length; i++)
        selectedPassenger[0][i] = false;
    }
    if (event.target) {
      this.setState({
        agree: event.target.checked,
        selectedPassenger,
        selectedPassengerId: 0,
      });
    }
  };
  handleSelectChange = (id, passengerIndex, event, price) => {
    let { selectedPassenger } = this.state;
    // calculate total price
    if (event.target.checked) penaltyTotalPrice += price;
    else penaltyTotalPrice -= price;

    for (let index = 0; index < selectedPassenger.length; index++) {
      selectedPassenger[index][passengerIndex] = event.target.checked;
    }
    if (!selectedPassenger.length) {
      selectedPassenger.push({ [passengerIndex]: event.target.checked });
    }
    this.setState({ selectedPassenger, selectedPassengerId: id });
  };
  //#endregion

  //#region useFull Function
  cancelTicketTypeChange = (index) => {
    this.setState({ cancelFlightIndex: index });
  };
  resetSelectedPassenger = (id) => {
    let { flights, selectedPassenger } = this.props;
    let { cancelFlightIndex } = this.state;
    let flightIndex = [];
    if (cancelFlightIndex === 0) {
      flights
        .filter((item) => item._id === id)[0]
        .flights.itineraries.map((flight, index) => {
          flightIndex.push(parseInt(index));
        });
    } else flightIndex.push(parseInt(cancelFlightIndex));
    penaltyTotalPrice = 0;
    if (selectedPassenger[0])
      for (let i = 0; i < Object.entries(selectedPassenger[0]).length; i++)
        selectedPassenger[0][i] = false;
    this.setState(
      { selectedPassenger, selectedPassengerId: 0, step: 2 },
      () => {
        try {
          bookingApi
            .penalty_price({ data: { id, flightIndex } })
            .then((result) => {
              //if result of penalty price has -1 then we set hasUndefinedPrice=>true to show unknown to user and crm
              this.setState({
                showNextStep: true,
                penalty: result.payload.data,
                hasUndefinedPrice:
                  result.payload.data.filter((item) => item.penalty === -1)
                    .length > 0,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        } catch (error) {
          console.error(error);
        }
      },
    );
  };
  // check if passnger for this flight cancel or not before
  checkPassengerCanceled = (tickets, passengerIndex) => {
    let { cancelFlightIndex } = this.state;
    if (
      tickets &&
      tickets.find(
        (item) =>
          item.flightIndex === cancelFlightIndex &&
          item.passengerIndex === passengerIndex &&
          item.status.filter((r) => parseInt(r.code) !== 5).length > 0,
      )
    )
      return true;
    else return false;
  };
  checkValidation = () => {
    // if any passenger selected for cancel or not
    for (let key in this.props.selectedPassenger[0]) {
      if (this.props.selectedPassenger[0][key]) {
        return false;
      }
    }
    return true;
  };
  //#endregion

  //#region  Render
  renderReasonButton = (id) => {
    return (
      <div className="d-flex w-100 justify-content-end  align-items-end">
        <button
          name={`reason-button-${id}`}
          id={`reason-button-${id}`}
          className="btn btn-primary "
          disabled={!this.state.agree}
          onClick={() => this.resetSelectedPassenger(id)}
        >
          <FormattedMessage id="booking.nextstep" />
        </button>
      </div>
    );
  };
  //render type of flight to cancel
  renderChooseTicket = (id) => {
    let { cancelFlightType, cancelFlightIndex } = this.state;
    return (
      <React.Fragment>
        <FormattedMessage id="booking.chooseticket" />
        <div className="d-flex border-bottom flex-column col-12 justify-content-start align-items-start px-0">
          <div className="custom-control custom-radio pt-2" key="roundtrip">
            <RadioButton
              id="roundtrip"
              name={`CancelRadio${id}`}
              label="booking.cancelroundtrip"
              inputClassName={`font-smaller  text-dark  border-0 font-weight-bold `}
              checked={cancelFlightIndex === 0 ? true : false}
              onChange={() => this.cancelTicketTypeChange(0)}
              value={cancelFlightType}
            />
          </div>
          <div className="custom-control custom-radio pt-2" key="return">
            <RadioButton
              id="return"
              name={`CancelRadio${id}`}
              label="booking.cancelreturn"
              inputClassName={`font-smaller  text-dark  border-0 font-weight-bold `}
              checked={cancelFlightIndex === 1 ? true : false}
              onChange={() => this.cancelTicketTypeChange(1)}
              value={cancelFlightType}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };
  renderChooseMultiCityTicket = (item) => {
    let { cancelFlightType, cancelFlightIndex } = this.state;
    return (
      <React.Fragment>
        <FormattedMessage id="booking.chooseticket" />
        <div className="border-bottom flex-column col-12 justify-content-start align-items-start">
          <div className="custom-control custom-radio py-3" key="allMultiCity">
            <RadioButton
              id={`radio${0}`}
              name={`CancelRadio${item._id}`}
              label="booking.cancelroundtrip"
              inputClassName={`font-smaller  text-dark  border-0 font-weight-bold `}
              checked={cancelFlightIndex === 0 ? true : false}
              onChange={() => this.cancelTicketTypeChange(0)}
              value={cancelFlightType}
            />
          </div>
          {/* map on list for each flight to be cancel indivual */}
          {item &&
            item.flights &&
            item.flights.length > 0 &&
            item.flights.map((fly, index) => (
              <div
                className="custom-control custom-radio py-3 d-flex"
                key={`fly${index}`}
              >
                <RadioButton
                  id={`radio${index + 1}`}
                  name={`CancelRadio${item._id}`}
                  label={`${
                    fly.flights[0].departureAirport.cityName[
                      this.props.language.name
                    ]
                  }-${
                    fly.flights[fly.flights.length - 1].arrivalAirport.cityName[
                      this.props.language.name
                    ]
                  }`}
                  inputClassName={`font-smaller text-start text-dark  border-0 font-weight-bold `}
                  value={cancelFlightType}
                  checked={cancelFlightIndex === index + 1 ? true : false}
                  onChange={() => this.cancelTicketTypeChange(index + 1)}
                />

                <div className="d-flex col-4 p-0 justify-content-center">
                  {this.props.language.direction === 'ltr'
                    ? new Date(fly.flights[0].departureDateTime)
                        .toISOString()
                        .split('T')[0]
                    : momentjs(
                        fly.flights[0].departureDateTime.split('T')[0],
                        'YYYY-M-D',
                      ).format('jYYYY-jMM-jDD')}
                </div>

                <div className="col-4 p-0">{fly.flights[0].flightNumber}</div>
              </div>
            ))}
        </div>
      </React.Fragment>
    );
  };
  //call api for cancel ticket
  renderSendRequest = (id) => {
    return (
      <div className="d-flex justify-content-center text-uppercase text-white">
        <button
          name={`request-button-${id}`}
          id={`request-button-${id}`}
          onClick={() => this.cancelTickets(id)}
          className="btn btn-primary  p-2"
        >
          <FormattedMessage id="booking.nextstep" />
        </button>
      </div>
    );
  };
  // render payment type for return money
  renderPaymentModal = (item) => {
    return (
      <React.Fragment>
        <div className="d-flex flex-column align-items-start justify-content-start w-100  font-weight-bold font-small px-3">
          <div className="custom-control custom-radio py-3 text-start">
            <input
              type="radio"
              id="rdbtnCredit"
              name={`customRadio${item._id}`}
              className="custom-control-input"
              checked={this.state.creditPayment}
              value={this.state.creditPayment}
              onChange={() => this.setState({ creditPayment: true })}
            />
            <label
              className="custom-control-label text-dark text-uppercase"
              htmlFor="rdbtnCredit"
            >
              <FormattedMessage id="booking.chargecredit" />
            </label>
            <div className="text-third font-smaller  pt-2">
              <FormattedMessage id="booking.chargecreditinfo" />
            </div>
          </div>
          <div className="custom-control custom-radio py-3  text-start">
            <input
              type="radio"
              id="rdbtnDeposit"
              name={`customRadio${item._id}`}
              className="custom-control-input"
              value={!this.state.creditPayment}
              checked={!this.state.creditPayment}
              onChange={() => this.setState({ creditPayment: false })}
            />

            <label
              className="custom-control-label text-dark text-uppercase"
              htmlFor="rdbtnDeposit"
            >
              <FormattedMessage id={`booking.deposit`} />
            </label>
            <div className="text-third font-smaller pt-2 ">
              <FormattedMessage id="booking.depositinfo" />
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <div className="d-flex w-100 py-2 justify-content-end align-items-end ">
            <div className="d-flex w-50 flex-start justify-content-start cursor-pointer">
              {this.renderPreviosStep()}
            </div>
            <div className="d-flex w-50 flex-end justify-content-end cursor-pointer ">
              {this.renderSendRequest(item._id)}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  renderPreviosStep = () => {
    let { step } = this.state;
    document.getElementById('roundtrip').setAttribute('checked', 'true');
    return (
      <div className="d-flex justify-content-center ">
        <button
          name={`previos-button`}
          id={`previos-button`}
          className="btn btn-third text-white p-2"
          onClick={() => {
            this.setState({ step, radioObj: this.props.radioObj });
          }}
        >
          <FormattedMessage id="booking.previousstep" />
        </button>
      </div>
    );
  };
  // render each reason for flight
  renderReason = (id) => {
    let { radioObj } = this.state;
    return (
      <div
        className="d-flex border-bottom py-1 flex-column col-12 text-third justify-content-start align-items-start px-0"
        key={`problem${id}`}
      >
        {radioObj.map((item, index) => {
          return (
            <div
              className="custom-control custom-radio py-1"
              key={`radio-${index}`}
            >
              <RadioButton
                name={`rdbtnReason${id}`}
                label={`booking.${item.name}`}
                inputClassName={`font-smaller  text-dark  border-0 font-weight-bold `}
                checked={item.selected}
                onChange={() => this.handlerchange(index)}
                value={item.selected}
              />
            </div>
          );
        })}
      </div>
    );
  };
  renderCancelModal = (item) => {
    let { penalty, cancelFlightIndex } = this.state,
      penaltyPrice = 0,
      { passengerLst } = this.props;
    return (
      <React.Fragment>
        <table className="table pt-0 table-striped table-responsive-md text-center font-smaller table-bordered">
          <thead>
            <tr>
              <th scope="col">
                <FormattedMessage id="booking.index" />
              </th>

              <th scope="col">
                <FormattedMessage id="booking.firstname" />
              </th>
              <th scope="col">
                <FormattedMessage id="user.lastname" />
              </th>
              <th scope="col">
                <FormattedMessage id="booking.price" />
              </th>
              <th scope="col">
                <FormattedMessage id="booking.penaltyPrice" />
              </th>
              <th scope="col">
                <FormattedMessage id="booking.returnprice" />
              </th>
              <th scope="col">
                <FormattedMessage id="booking.cancelstatus" />
              </th>
            </tr>
          </thead>
          <tbody>
            {passengerLst.map((item, index) => {
              return (
                <tr key={`row-${index}`}>
                  <th scope="row">{index + 1} </th>

                  <td scope="row">
                    <>
                      <div className="custom-control  text-center custom-checkbox align-item-center justify-content-center d-flex  col-1">
                        <input
                          disabled={this.checkPassengerCanceled(tickets, index)}
                          type="checkbox"
                          className="custom-control-input "
                          id={`chkboxSelect-${id}-${index}`}
                          onChange={(event) =>
                            this.handleSelectChange(id, index, event, price)
                          }
                          checked={
                            this.props.selectedPassenger[0]
                              ? this.props.selectedPassenger[0][index]
                              : false
                          }
                        />
                        <label
                          className="custom-control-label text-info mx-2"
                          htmlFor={`chkboxSelect-${id}-${index}`}
                        />
                      </div>
                      {!this.props.isMobile ? (
                        <img
                          src={require(`../../../../content/images/avatars/${
                            avatar ? avatar : '1.png'
                          }`)}
                          style={{ width: 30, height: 30 }}
                          alt="avatars"
                        />
                      ) : null}
                    </>
                  </td>
                  <td scope="row">{numberWithCommas(price)}</td>

                  <td scope="row">
                    {numberWithCommas(
                      price -
                        penaltyPriceFlight.filter(
                          (itm) =>
                            itm.passengerIndex === cancelFlightIndex &&
                            itm.flightIndex === index,
                        ).length
                        ? penaltyPriceFlight.filter(
                            (itm) =>
                              itm.flightIndex === cancelFlightIndex &&
                              itm.passengerIndex === index,
                          )[0].penalty / 100
                        : 0,
                    )}
                  </td>
                  <td scope="row">
                    {numberWithCommas(
                      price -
                        (price -
                        penaltyPriceFlight.filter(
                          (itm) =>
                            itm.passengerIndex === cancelFlightIndex &&
                            itm.flightIndex === index,
                        ).length
                          ? penaltyPriceFlight.filter(
                              (itm) =>
                                itm.flightIndex === cancelFlightIndex &&
                                itm.passengerIndex === index,
                            )[0].penalty / 100
                          : 0),
                    )}
                  </td>
                  <td scope="row">
                    {this.checkPassengerCanceled(itemFlight.tickets, index)
                      ? itemFlight.tickets.filter(
                          (item) =>
                            item.flightIndex === cancelFlightIndex &&
                            item.passengerIndex === index,
                        )[0].status[0].name[name]
                      : '--'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* <div
          className="d-flex flex-column  w-100 font-small border-1 border-third rounded overflow-hidden"
          style={{ border: "1px solid" }}
        >
          <div className="d-flex border-bottom py-3 px-1 flex-row col-12 text-dark justify-content-center font-smaller bg-gray">
            <div className="font-weight-bold col-1 text-center p-0" />
            <div className="font-weight-bold col-2 text-center p-0">
              <FormattedMessage id="booking.passengername" />
            </div>
            <div className="font-weight-bold col-2 text-center p-0">
              <FormattedMessage id="booking.price" />
            </div>
            <div className="font-weight-bold col-3 text-center p-0">
              <FormattedMessage id="booking.penaltyprice" />
            </div>
            <div className="font-weight-bold col-2 text-center p-0">
              <FormattedMessage id="booking.returnprice" />
            </div>
            <div className="font-weight-bold col-2 text-center p-0">
              <FormattedMessage id="booking.cancelstatus" />
            </div>
          </div>
          {this.renderCancelPassengers(item)}
        </div>

        <div className="d-flex w-100 pt-2 justify-content-end align-items-center ">
          {item.tickets
            .filter((item) => item.flightIndex === this.state.cancelFlightIndex)
            .filter((pass) => pass.passengerIndex).length ===
          this.props.passengerLst.length ? (
            <span className="text-third font-weight-bold font-small">
              {" "}
              <FormattedMessage id="booking.notrefundable" />
            </span>
          ) : (
            <React.Fragment>
              <span className="text-dark font-weight-bold font-smaller">
                {" "}
                <FormattedMessage id="booking.sumcancelprice" />
              </span>{" "}
              :
              <span className="text-secondary font-weight-bold px-1 font-smaller">
                {this.state.hasUndefinedPrice
                  ? this.props.intl.formatMessage({
                      id: "booking.unknown",
                    })
                  : numberWithCommas(penaltyTotalPrice)}
              </span>
            </React.Fragment>
          )}
        </div>
        <hr />
        <div className="d-flex w-100 py-2 justify-content-end align-items-end ">
          <div className="d-flex w-50 flex-start justify-content-start cursor-pointer">
            {this.renderPreviosStep()}
          </div>
          <div className="d-flex w-50 flex-end justify-content-end cursor-pointer ">
            {this.renderCancel(item._id)}
          </div>
        </div>
      */}
      </React.Fragment>
    );
  };
  renderCancelReason = (item) => {
    let { step } = this.state,
      { isMobile } = this.props;
    let Title =
      step == 1 || step === 4
        ? 'booking.cancel'
        : step === 2
        ? 'booking.passenger'
        : step === 3
        ? 'booking.paymenttype'
        : '';
    return (
      <Modal
        title={
          <h5 className="modal-title text-center w-100 font-weight-bold text-uppercase text-white">
            <FormattedMessage id={Title} />
          </h5>
        }
        isOpen={this.props?.isOpen}
        onClose={this.props?.onClose}
      >
        <div className="modal-body">
          {step === 1 && (
            <div
              className={`d-flex flex-column align-items-start  w-100 text-uppercase font-weight-bold ${
                checkMobileDevice() ? 'font-smaller' : 'font-small'
              }`}
            >
              {item.flights.flightType === 'roundtrip' &&
                this.renderChooseTicket(item._id)}
              {
                item.flights.flightType === 'multicity' &&
                  this.renderChooseMultiCityTicket(item) //render each flight of multicity
              }
              <span className="pt-3 px-2">
                <FormattedMessage id="booking.cancelreason" />
              </span>
              {this.renderReason(item._id)}
              {this.renderAgreeCheckbox(item._id)}
              {this.renderReasonButton(item._id)}
            </div>
          )}
          {step === 2 && this.renderCancelModal(item)}
          {step === 3 && this.renderPaymentModal(item)}
          {step === 4 && this.renderFinalStepModal()}
        </div>
      </Modal>
    );
    // return (
    //   <div className="modal-dialog modal-lg mt-5">
    //     <div
    //       className="modal-content"
    //       style={{ width: isMobile ? "99%" : "135%" }}
    //     >
    //       <div className="modal-header  pt-3 bg-primary">
    //         <h5 className="modal-title text-center w-100 font-weight-bold text-uppercase text-white">
    //           <FormattedMessage id={Title} />
    //         </h5>
    //         <button
    //           type="button"
    //           className="close text-white"
    //           data-dismiss="modal"
    //           onClick={() =>
    //             step === 4 &&
    //             this.props.fetchFlightInfo(
    //               this.props.flag ? this.props.flag : null
    //             )
    //           }
    //         >
    //           &times;
    //         </button>
    //       </div>
    //       <div className="modal-body">
    //         {step === 1 && (
    //           <div
    //             className={`d-flex flex-column align-items-start  w-100 text-uppercase font-weight-bold ${
    //               checkMobileDevice() ? "font-smaller" : "font-small"
    //             }`}
    //           >
    //             {item.flights.flightType === "roundtrip" &&
    //               this.renderChooseTicket(item._id)}
    //             {
    //               item.flights.flightType === "multicity" &&
    //                 this.renderChooseMultiCityTicket(item) //render each flight of multicity
    //             }
    //             <span className="pt-3 px-2">
    //               <FormattedMessage id="booking.cancelreason" />
    //             </span>
    //             {this.renderReason(item._id)}
    //             {this.renderAgreeCheckbox(item._id)}
    //             {this.renderReasonButton(item._id)}
    //           </div>
    //         )}
    //         {step === 2 && this.renderCancelModal(item)}
    //         {step === 3 && this.renderPaymentModal(item)}
    //         {step === 4 && this.renderFinalStepModal()}
    //       </div>
    //     </div>
    //   </div>
    // );
  };
  // checkbox for each passenger
  renderSelectCheckBox = (id, index, price, tickets, avatar) => {
    return (
      <>
        <div className="custom-control  text-center custom-checkbox align-item-center justify-content-center d-flex  col-1">
          <input
            disabled={this.checkPassengerCanceled(tickets, index)}
            type="checkbox"
            className="custom-control-input "
            id={`chkboxSelect-${id}-${index}`}
            onChange={(event) =>
              this.handleSelectChange(id, index, event, price)
            }
            checked={
              this.props.selectedPassenger[0]
                ? this.props.selectedPassenger[0][index]
                : false
            }
          />
          <label
            className="custom-control-label text-info mx-2"
            htmlFor={`chkboxSelect-${id}-${index}`}
          />
        </div>
        {!this.props.isMobile ? (
          <img
            src={require(`../../../../content/images/avatars/${
              avatar ? avatar : '1.png'
            }`)}
            style={{ width: 30, height: 30 }}
            alt="avatars"
          />
        ) : null}
      </>
    );
  };
  renderCancelData = (value, isNumber, colClass) => {
    return (
      <div
        className={`font-weight-bold text-center ${colClass} ${
          checkMobileDevice() ? 'font-xsmall' : 'font-smaller'
        }`}
      >
        {isNumber
          ? parseInt(value) > 0
            ? numberWithCommas(value)
            : this.props.intl.formatMessage({ id: 'booking.unknown' })
          : value.toString()}
      </div>
    );
  };
  renderCancelPassengers = (itemFlight) => {
    let { name } = this.props.language;
    let { passengerLst } = this.props;
    let { penalty, cancelFlightIndex } = this.state;
    let penaltyPrice = 0;
    if (passengerLst.length > 0)
      return passengerLst.map((item, index) => {
        penalty &&
          penalty.length &&
          penalty.map((element, ind) => {
            if (itemFlight.flights.itineraries[0].price) {
              let eachPenaltyprice = 0;
              if (element.penalty !== -1) {
                switch (item.type) {
                  case 'adult':
                    eachPenaltyprice =
                      (itemFlight.flights.itineraries[element.flightIndex].price
                        .adultPrice.totalPrice *
                        element.penalty) /
                      100;
                    penaltyPrice += eachPenaltyprice;
                    break;
                  case 'child':
                    eachPenaltyprice =
                      (itemFlight.flights.itineraries[element.flightIndex].price
                        .childPrice.totalPrice *
                        element.penalty) /
                      100;
                    penaltyPrice += eachPenaltyprice;

                    break;
                  case 'infant':
                    eachPenaltyprice =
                      (itemFlight.flights.itineraries[element.flightIndex].price
                        .infantPrice.totalPrice *
                        element.penalty) /
                      100;
                    penaltyPrice += eachPenaltyprice;
                    break;
                  default:
                    break;
                }
              } else eachPenaltyprice = 0;
              penaltyPriceFlight.push({
                passengerIndex: index,
                flightIndex: element.flightIndex,
                penalty: eachPenaltyprice,
              });
            } else {
              penalty &&
                penalty.length &&
                penalty.map((element, ind) => {
                  let eachPenaltyprice = 0;
                  if (element.penalty !== -1) {
                    eachPenaltyprice =
                      (item.price.totalPrice * element.penalty) / 100;
                  } else eachPenaltyprice = 0;
                  penaltyPrice += eachPenaltyprice;

                  penaltyPriceFlight.push({
                    passengerIndex: index,
                    flightIndex: element.flightIndex,
                    penalty: eachPenaltyprice,
                  });
                });
            }
          });

        let price = item.price.totalPrice / 10;

        return (
          <div
            className="d-flex flex-row border-bottom py-3 px-1 flex-row w-100 text-dark justify-content-center align-items-center font-small "
            key={index}
          >
            {this.renderSelectCheckBox(
              itemFlight._id,
              index,
              price - penaltyPrice / 10,
              itemFlight.tickets,
              item.avatar,
            )}

            {this.renderCancelData(
              `${item.firstName} ${item.lastName}`,
              false,
              'col-2 p-0 ',
            )}

            {this.renderCancelData(price, true, 'col-2 p-0 ')}
            {penaltyPriceFlight.length
              ? this.renderCancelData(
                  price -
                    penaltyPriceFlight.filter(
                      (itm) =>
                        itm.passengerIndex === cancelFlightIndex &&
                        itm.flightIndex === index,
                    ).length
                    ? penaltyPriceFlight.filter(
                        (itm) =>
                          itm.flightIndex === cancelFlightIndex &&
                          itm.passengerIndex === index,
                      )[0].penalty / 100
                    : 0,
                  true,
                  'col-3 text-third p-0',
                )
              : null}
            {penaltyPriceFlight.length
              ? this.renderCancelData(
                  price -
                    (price -
                    penaltyPriceFlight.filter(
                      (itm) =>
                        itm.passengerIndex === cancelFlightIndex &&
                        itm.flightIndex === index,
                    ).length
                      ? penaltyPriceFlight.filter(
                          (itm) =>
                            itm.flightIndex === cancelFlightIndex &&
                            itm.passengerIndex === index,
                        )[0].penalty / 100
                      : 0),
                  true,
                  'col-2 p-0 ',
                )
              : null}
            {this.renderCancelData(
              this.checkPassengerCanceled(itemFlight.tickets, index)
                ? itemFlight.tickets.filter(
                    (item) =>
                      item.flightIndex === cancelFlightIndex &&
                      item.passengerIndex === index,
                  )[0].status[0].name[name]
                : '--',
              false,
              'col-2 text-secondary font-smaller',
            )}
          </div>
        );
      });
  };
  renderCancel = (id) => {
    return (
      <div className="d-flex justify-content-center text-uppercase text-white">
        <button
          name={`cancel-button-${id}`}
          id={`cancel-button-${id}`}
          disabled={this.checkValidation()}
          className="btn btn-primary   p-2"
          onClick={() => this.setState({ step: 3 })}
        >
          <FormattedMessage id="booking.nextstep" />
        </button>
      </div>
    );
  };

  renderAgreeCheckbox = (_id) => {
    let { direction } = this.props.language;
    return (
      <div className="d-flex flex-column  w-100 px-1 my-2">
        {direction === 'ltr' ? (
          <div className="d-flex justify-content-start custom-control align-items-center custom-checkbox  p-0">
            <Checkbox
              id={`chkAgree${_id}`}
              label=""
              isLocalization={false}
              checked={this.state.agree}
              value={this.state.agree}
              name={`chkAgree${_id}`}
              inputClassName="font-smaller font-weight-bold pt-2"
              parentInputClassName="font-small font-weight-bold p-0 m-0"
              onChange={(event) => {
                this.handlerAgreechange(event);
              }}
            />
            <span className=" d-flex px-1">
              <FormattedMessage id="booking.agree" />
            </span>

            <a
              target="_blank"
              href={`${profileRoutes.rules}?section="domestic_fine"`}
              className="text-primary font-weight-bold text-underline px-1 d-flex"
            >
              <FormattedMessage id="booking.cancelrules" />
            </a>
          </div>
        ) : (
          <div className="d-flex justify-content-start custom-control align-items-center custom-checkbox ">
            <Checkbox
              name={`chkAgree${_id}`}
              label=""
              isLocalization={false}
              checked={this.state.agree}
              value={this.state.agree}
              id={`chkAgree${_id}`}
              inputClassName="font-smaller font-weight-bold pt-2"
              parentInputClassName="font-small font-weight-bold p-0 m-0"
              onChange={(event) => {
                this.handlerAgreechange(event);
              }}
            />

            <a
              target="_blank"
              href={`${profileRoutes.rules}?section="domestic_fine"`}
              className="text-primary font-weight-bold text-underline px-1 d-flex align-items-center"
            >
              <FormattedMessage id="booking.cancelrules" />
            </a>
            <span className="d-flex align-items-center"></span>
            <FormattedMessage id="booking.agree" />
          </div>
        )}
      </div>
    );
  };
  //show  passenger choose of payment type  and hint user that his request send succesfully
  renderFinalStepModal = () => {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center w-100 ">
        <div className="d-flex py-2">
          <img
            // style={{ width: 23, height: 35 }}
            alt="cancel-ticket"
            src={require('../../../../content/images/icon/cancel-ticket-icon.png')}
          />
        </div>
        <div className="text-muted font-weight-bold font-medium pt-4 pb-2 w-100 text-center">
          <FormattedMessage id="booking.cancelmessage" />
        </div>
        {this.state.creditPayment && (
          <div className="text-muted font-medium font-weight-bold pb-5 pt-1 text-center w-100">
            <FormattedMessage id="booking.chargecreditinfo" />
          </div>
        )}
        {!this.state.creditPayment && (
          <div className="text-muted font-medium font-weight-bold pb-5 pt-1 text-center w-100 px-3">
            <FormattedMessage id="booking.depositinfo" />
          </div>
        )}
        <div className="text-third font-small pt-2 font-weight-bold ">
          <FormattedMessage id="booking.contactus" />
        </div>
      </div>
    );
  };

  render() {
    return <>{this.renderCancelReason(this.props.item)}</>;
  }
  //#endregion
}
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
//#region  prototype
CancelingProcessModal.propTypes = {
  item: propTypes.object,
  flag: propTypes.string,
  flights: propTypes.array,
  cancelFlightType: propTypes.string,
  passengerLst: propTypes.array,
  cancelFlightIndex: propTypes.number,
  radioObj: propTypes.array,
  selectedPassenger: propTypes.array,
  currentFlightId: propTypes.string,
  fetchFlightInfo: propTypes.func,
};
//#endregion

//#region  defaultProps
CancelingProcessModal.defaultProps = {
  item: {},
  flag: 'issued',
  flights: [],
  cancelFlightType: '',
  passengerLst: [],
  cancelFlightIndex: 0,
  radioObj: [
    { name: 'personalproblem', selected: true },
    { name: 'airlineproblem', selected: false },
    { name: 'flightproblem', selected: false },
  ],
  selectedPassenger: [],
  currentFlightId: {},
  fetchFlightInfo: () => {
    console.error(
      "CancelingProcessModal component hasn't fetchFlightInfo function",
    );
  },
};
//#endregion

export default injectIntl(connect(mapStateToProps)(CancelingProcessModal));
